module.exports = __webpack_public_path__ + "media/icons-lj-styleguide-2025/circle-check-178e3c06.svg";